import { Outlet, useNavigate } from "react-router-dom";
import Cookie from "js-cookie"
import { DataProvider } from "./PartnerContext";
import { useEffect } from "react";

const PartnerRequireAuth = () => {
  const pageRender = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const prof_id = queryParams.get("prof_id_partner");

  if (prof_id !== null) {
    var uri = window.location.toString()
    if (uri.indexOf("?") > 0) {
      var clean_uri = uri.substring(0, uri.indexOf("?"));
      window.history.replaceState({}, document.title, clean_uri);

      if (prof_id) {
        Cookie.set("prof_id_partner", prof_id)
      }
    }
  }

  useEffect(() => {
    if (!Cookie.get("prToken")) {
      pageRender("/")
      return;
    }
  }, [])


  return Cookie.get("prToken") ?
    <DataProvider >
      <Outlet />
    </DataProvider >
    :
    null
}


export default PartnerRequireAuth
